export default __webpack_public_path__ + "static/media/nectar-sweet.813d3521.webp";